// LMIRForm.js
import React, { useState, useMemo, useEffect } from "react";
import "./LMIRForm.css";
import { useEtatGlobal } from "../../../EtatGlobal.js";
// import { IoSearchSharp } from "react-icons/io5";
import { User, Building2, ChevronDown, Check, Calendar } from "lucide-react";
import { Input } from "../../../../components/ui/input.js";
import { Select } from "../../../../components/ui/select.js";
import CabinetSelect from "../../components/CabinetSelect";
import SelectOuAutre from "../../components/SelectOuAutre";
import { CIVILITE_OPTIONS } from "../../components/lmSelectOptions";

function LMIRForm({
  handleInputChange,
  handleCheckboxChange,
  setDetailsMission,
  setDetailsHonoraire,
}) {
  // const [numSiret, setNumSiret] = useState("");
  // const [isLoading, setIsLoading] = useState(false);
  // const [showTextarea, setShowTextarea] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const [isOpenMission, setIsOpenMission] = useState(true);

  // const handleNumSiretChange = (e) => {
  //   setNumSiret(e.target.value);
  // };

  // const handleSearchSiret = async () => {
  //   if (numSiret.length !== 14) {
  //     dialog.alert("Le numéro SIRET doit contenir 14 chiffres");
  //     return;
  //   }

  //   try {
  //     setIsLoading(true);
  //     const response = await fetch(
  //       `https://backend-myalfa.vercel.app/api/siret/${numSiret}`
  //     );
  //     const data = await response.json();
  //     if (data.success) {
  //       const {
  //         siren,
  //         denominationUniteLegale,
  //         sexeUniteLegale,
  //         adresse,
  //         nomUniteLegale,
  //         prenomUsuelUniteLegale,
  //       } = data;

  //       setFormData((prev) => ({
  //         ...prev,
  //         siren: siren || "",
  //         nom_client: denominationUniteLegale || "",
  //         adresse: adresse
  //           ? `${adresse.numeroVoie || ""} ${adresse.typeVoie || ""} ${
  //               adresse.libelleVoie || ""
  //             }, ${adresse.codePostal || ""} ${adresse.libelleCommune || ""}`
  //           : "",
  //         nom: nomUniteLegale || "",
  //         prenom: prenomUsuelUniteLegale || "",
  //         civilite_lm: sexeUniteLegale === "F" ? "Madame" : "Monsieur",
  //       }));
  //     } else {
  //       dialog.alert("Aucune donnée trouvée pour ce numéro SIRET.");
  //     }
  //   } catch (error) {
  //     console.error("Erreur lors de la recherche SIRET :", error);
  //     dialog.alert("Erreur lors de la recherche. Vérifiez le serveur.");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const { formData, setFormData } = useEtatGlobal();

  const isValid = useMemo(() => {
    // liste des champs à vérifier
    // "adresse" n'est pas obligatoire — nullable, laissée vide dans le LM
    // généré si non renseignée.
    const requiredFields = [
      "nom_client",
      "lieu_collab",
      "nom",
      "prenom",
      "email",
      "telephone",
    ];

    // retourne true seulement si tous les champs sont remplis (non vides)
    return requiredFields.every((field) => {
      const value = formData[field];
      return (
        value !== " " && value !== null && value !== undefined && value !== ""
      );
    });
  }, [formData]);

  const isValidHonoraire = useMemo(() => {
    // liste des champs à vérifier
    const requiredFields = ["hono_ir"];

    // retourne true seulement si tous les champs sont remplis (non vides)
    return requiredFields.every((field) => {
      const value = formData[field];
      return (
        value !== " " && value !== null && value !== undefined && value !== ""
      );
    });
  }, [formData]);

  const isValidMission = useMemo(() => {
    // Vérifie les champs obligatoires simples
    const requiredFields = ["pr_annee"];
    const areRequiredFieldsFilled = requiredFields.every((field) => {
      const value = formData[field];
      return (
        value !== " " && value !== null && value !== undefined && value !== ""
      );
    });

    // Vérifie que au moins une des missions est cochée
    const missions = [
      formData.declaration_ir,
      formData.declaration_tns,
      formData.declaration_ds,
      formData.declaration_ifi,
    ];
    const isAtLeastOneMissionChecked = missions.some(
      (mission) =>
        mission !== "☐" &&
        mission !== "" &&
        mission !== null &&
        mission !== undefined,
    );

    return areRequiredFieldsFilled && isAtLeastOneMissionChecked;
  }, [formData]);

  useEffect(() => {
    if (isValidMission) {
      setDetailsMission(true);
    } else {
      setDetailsMission(false); // facultatif si tu veux réinitialiser quand invalide
    }
  }, [isValidMission, setDetailsMission]);

  useEffect(() => {
    if (isValidHonoraire) {
      setDetailsHonoraire(true);
    } else {
      setDetailsHonoraire(false); // facultatif si tu veux réinitialiser quand invalide
    }
  }, [isValidHonoraire, setDetailsHonoraire]);

  // "Nom du client" ne se pré-remplit qu'une fois, tant que le champ est
  // encore vide (valeur initiale " ") — à partir du contact référent
  // (nom + prénom). Avant ce correctif, cette valeur n'était qu'un
  // recalcul d'affichage jamais écrit dans formData.nom_client : le champ
  // semblait rempli à l'écran mais restait vide côté validation/génération
  // du document, sans qu'il soit possible de le corriger (champ readOnly).
  useEffect(() => {
    const isBlank = !formData.nom_client || formData.nom_client.trim() === "";
    const hasContactName = formData.nom?.trim() || formData.prenom?.trim();
    if (isBlank && hasContactName) {
      setFormData((prev) => ({
        ...prev,
        nom_client: `${formData.nom} ${formData.prenom}`.trim(),
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.nom, formData.prenom]);

  return (
    <div className="Container">
      <div>
        <div
          className="border-2 border-slate-200 rounded-xl bg-white overflow-hidden"
          style={{ padding: "10px" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            className="p-4 hover:bg-slate-50 transition-colors rounded-lg mb-5"
            onClick={() => setIsOpen(!isOpen)}
          >
            <div
              style={{
                display: "flex",
                gap: "25px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                className={`w-10 h-10 rounded-lg flex items-center justify-center transition-colors ${
                  isValid
                    ? "bg-emerald-100 text-emerald-700"
                    : "bg-slate-100 text-slate-600"
                }`}
              >
                {isValid ? (
                  <Check className="w-5 h-5" />
                ) : (
                  <Building2 className="w-5 h-5" />
                )}
              </div>

              <h3
                className="font-semibold text-slate-800"
                style={{ margin: 0 }}
              >
                1. Votre entité
              </h3>
            </div>
            <ChevronDown
              className={`w-5 h-5 text-slate-400 transition-transform ${
                isOpen ? "rotate-180" : ""
              }`}
            />
          </div>
          {isOpen && (
            <div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="p-6 pt-0 space-y-6"
            >
              <div className="grid md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <div className="grid grid-cols-1 gap-4">
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Nom du client
                      </label>
                      {Array.isArray(formData.annuaireClients) &&
                      formData.annuaireClients.length > 1 ? (
                        <Select
                          name="nom_client"
                          value={formData.nom_client}
                          onChange={handleInputChange}
                          className="bg-white border-slate-200 h-9 text-sm"
                        >
                          {formData.annuaireClients.map((c) => (
                            <option key={c.id} value={c.nom}>
                              {c.nom}
                            </option>
                          ))}
                        </Select>
                      ) : (
                        <Input
                          type="text"
                          name="nom_client"
                          value={formData.nom_client}
                          onChange={handleInputChange}
                          className="bg-white border-slate-200 h-9 text-sm"
                        />
                      )}
                    </div>
                    {/* <div
                    className="siret-search"
                    style={{
                      display: "flex",
                      gap: "20px",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <label>Recherche Siret</label>
                      <input
                        type="text"
                        name="NumSiret"
                        value={numSiret}
                        onChange={handleNumSiretChange}
                        required
                      />
                    </div>

                    <div
                      onClick={handleSearchSiret}
                      disabled={isLoading}
                      style={{
                        marginTop: "7.5%",
                        color: "white",
                        background: "#840040",
                        padding: "2px 7.5px",
                        borderRadius: "4px",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      {isLoading ? (
                        <div
                          style={{
                            color: "white",
                            width: "10px",
                            height: "10px",
                            border: "2px solid #ccc",
                            borderTop: "2px solid #007BFF",
                            borderRadius: "50%",
                            animation: "spin 1s linear infinite",
                          }}
                        />
                      ) : (
                        <IoSearchSharp size={12} />
                      )}
                    </div>
                  </div> */}
                  </div>
                  <CabinetSelect />
                  <div>
                    <label className="text-slate-600 mb-1 block text-xs">
                      Adresse
                    </label>
                    <Input
                      type="text"
                      name="adresse"
                      value={formData.adresse}
                      onChange={handleInputChange}
                      className="bg-white border-slate-200 h-9 text-sm"
                    />
                  </div>
                </div>

                <div className="bg-slate-50 rounded-xl p-4 border border-slate-200">
                  <h4 className="font-semibold text-slate-700 mb-5 text-sm flex items-center gap-2">
                    <User className="w-4 h-4 text-[#8B1D41]" />
                    Contact Référent
                  </h4>
                  <div className="space-y-3">
                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <label className="text-slate-600 mb-1 block text-xs">
                          Civilité
                        </label>
                        <SelectOuAutre
                          name="civilite_lm"
                          value={formData.civilite_lm}
                          onChange={handleInputChange}
                          options={CIVILITE_OPTIONS}
                        />
                      </div>
                      <div>
                        <label className="text-slate-600 mb-1 block text-xs">
                          Nom
                        </label>
                        <Input
                          type="text"
                          name="nom"
                          value={formData.nom}
                          onChange={handleInputChange}
                          className="bg-white border-slate-200 h-9 text-sm"
                        />
                      </div>
                    </div>
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Prénom
                      </label>
                      <Input
                        type="text"
                        name="prenom"
                        value={formData.prenom}
                        onChange={handleInputChange}
                        className="bg-white border-slate-200 h-9 text-sm"
                      />
                    </div>
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Email
                      </label>
                      <Input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        className="bg-white border-slate-200 h-9 text-sm"
                      />
                    </div>
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Téléphone
                      </label>
                      <Input
                        type="text"
                        name="telephone"
                        value={formData.telephone}
                        onChange={handleInputChange}
                        className="bg-white border-slate-200 h-9 text-sm"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <br />
        <div
          className="border-2 border-slate-200 rounded-xl bg-white overflow-hidden"
          style={{ padding: "10px" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            className="p-4 hover:bg-slate-50 transition-colors rounded-lg mb-5"
            onClick={() => setIsOpenMission(!isOpenMission)}
          >
            <div
              style={{
                display: "flex",
                gap: "25px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                className={`w-10 h-10 rounded-lg flex items-center justify-center transition-colors ${
                  isValidMission && isValidHonoraire
                    ? "bg-emerald-100 text-emerald-700"
                    : "bg-slate-100 text-slate-600"
                }`}
              >
                {isValidMission && isValidHonoraire ? (
                  <Check className="w-5 h-5" />
                ) : (
                  <Calendar className="w-5 h-5" />
                )}
              </div>

              <h3
                className="font-semibold text-slate-800"
                style={{ margin: 0 }}
              >
                2. Notre mission
              </h3>
            </div>
            <ChevronDown
              className={`w-5 h-5 text-slate-400 transition-transform ${
                isOpen ? "rotate-180" : ""
              }`}
            />
          </div>
          {isOpenMission && (
            <div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="p-6 pt-0 space-y-6"
            >
              <div className="grid md:grid-cols-1 gap-6">
                <div className="grid grid-cols-4 gap-4">
                  <div>
                    <label className="text-slate-600 mb-1 block text-xs">
                      Première année
                    </label>
                    <Input
                      type="text"
                      name="pr_annee"
                      value={formData.pr_annee}
                      onChange={handleInputChange}
                      className="bg-white border-slate-200 h-9 text-sm"
                    />
                  </div>
                  <div>
                    <label className="text-slate-600 mb-1 block text-xs">
                      Honoraires IR
                    </label>
                    <Input
                      className="bg-white border-slate-200 h-9 text-sm"
                      type="text"
                      name="hono_ir"
                      placeholder="350,00"
                      value={formData.hono_ir}
                      onChange={(e) => {
                        let input = e.target.value;
                        // autorise seulement chiffres et virgule
                        input = input.replace(/[^\d,]/g, "");

                        // Met à jour hono_ir
                        setFormData((prev) => {
                          let updated = { ...prev, hono_ir: input };

                          // Conversion vers float pour calcul
                          let num = parseFloat(input.replace(",", "."));
                          if (!isNaN(num)) {
                            let mensuel = num / 12;
                            // Format en XX,XX
                            let formattedMensuel = mensuel
                              .toFixed(2)
                              .replace(".", ",");
                            updated.hono_ir_12 = formattedMensuel;
                          } else {
                            updated.hono_ir_12 = "";
                          }

                          return updated;
                        });
                      }}
                      onBlur={() => {
                        // Reformater hono_ir proprement au blur
                        let num = parseFloat(
                          formData.hono_ir.replace(",", "."),
                        );
                        if (!isNaN(num)) {
                          let formatted = num.toFixed(2).replace(".", ",");
                          setFormData((prev) => ({
                            ...prev,
                            hono_ir: formatted,
                          }));
                        } else {
                          setFormData((prev) => ({ ...prev, hono_ir: "" }));
                        }
                      }}
                    />
                  </div>
                  <div>
                    <label className="text-slate-600 mb-1 block text-xs">
                      Expert-Comptable
                    </label>
                    <Select
                      name="expert_comptable_nom"
                      value={formData.expert_comptable_nom}
                      onChange={handleInputChange}
                    >
                      <option value="Samuel HOARAU">Samuel HOARAU</option>
                      <option value="Anthony HOARAU">Anthony HOARAU</option>
                    </Select>
                  </div>
                  <div>
                    <label className="text-slate-600 mb-1 block text-xs">
                      Signataire
                    </label>
                    <Select
                      name="expert_comptable"
                      value={formData.expert_comptable}
                      onChange={handleInputChange}
                    >
                      <option value="Samuel HOARAU">Mrs Samuel HOARAU</option>
                      <option value="Anthony HOARAU">Mrs Anthony HOARAU</option>
                    </Select>
                  </div>
                </div>
                <div className="grid grid-cols-1 gap-4">
                  <div className="space-y-6">
                    <div className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        name="declaration_ir"
                        checked={formData.declaration_ir === "☒"}
                        onChange={handleCheckboxChange}
                        className="bg-white border-slate-200 h-9 text-sm"
                      />
                      <label className="text-slate-600  block text-xs">
                        Déclaration d’impôt sur le revenu (IR)
                      </label>
                    </div>

                    <div className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        name="declaration_tns"
                        checked={formData.declaration_tns === "☒"}
                        onChange={handleCheckboxChange}
                        className="bg-white border-slate-200 h-9 text-sm"
                      />
                      <label className="text-slate-600  block text-xs">
                        Déclarations annexes : volet social URSSAF (TNS)
                      </label>
                    </div>

                    <div className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        name="declaration_ds"
                        checked={formData.declaration_ds === "☒"}
                        onChange={handleCheckboxChange}
                        className="bg-white border-slate-200 h-9 text-sm"
                      />
                      <label className="text-slate-600  block text-xs">
                        Déclarations annexes : social des praticiens et
                        axillaires médicaux conventionnées (DS PAMC)
                      </label>
                    </div>

                    <div className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        name="declaration_ifi"
                        checked={formData.declaration_ifi === "☒"}
                        onChange={handleCheckboxChange}
                        className="bg-white border-slate-200 h-9 text-sm"
                      />
                      <label className="text-slate-600  block text-xs">
                        Déclaration d’impôt sur la fortune immobilière (IFI)
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <br />
    </div>
  );
}

export default LMIRForm;
